import React, { forwardRef } from 'react';
import { CustomItem as CustomItemDI } from '@atlaskit/menu';
import { Link as RouterLink, type LinkProps } from '@atlassian/react-resource-router';
import type { ItemProps } from './types.tsx';

type WrapperComponentProps = LinkProps;
const WrapperComponent = forwardRef<HTMLElement, WrapperComponentProps>(
	({ children, href, target, ...props }, ref) => {
		const commonProps = {
			...props,
			children,
			ref,
		};
		return href != null ? (
			// @ts-expect-error - TS2322 - Type '{ href: string; target: (HTMLAttributeAnchorTarget & ("_self" | "_blank" | "_parent" | "_top")) | undefined; children: ReactNode; ref: ((instance: LinkProps | null) => void) | MutableRefObject<...> | null; ... 266 more ...; prefetch?: false | ... 2 more ... | undefined; }' is not assignable to type 'RefAttributes<HTMLAnchorElement | HTMLButtonElement>'.
			<RouterLink {...commonProps} href={href} target={target} />
		) : (
			// @ts-expect-error - TS2322 - Type '{ children: ReactNode; ref: ((instance: LinkProps | null) => void) | MutableRefObject<LinkProps | null> | null; download?: any; ... 265 more ...; prefetch?: false | ... 2 more ... | undefined; }' is not assignable to type 'DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>'.
			<button {...commonProps}>{children}</button>
		);
	},
);

export const Item = ({
	CustomItem = CustomItemDI,
	// @ts-expect-error - component props do not match
	component = WrapperComponent,
	text = null,
	before = () => null,
	after = () => null,
	subText,
	className,
	...rest
}: ItemProps) => {
	const IconBefore = before;
	const IconAfter = after;

	const customProps = {
		...rest,
		className,
		component,
		description: subText,
		iconBefore: <IconBefore color="currentColor" />,
		iconAfter: <IconAfter color="currentColor" />,
		children: text,
	};

	return <CustomItem {...customProps} />;
};
